module.exports = __webpack_public_path__ + "static/thorass-common-75903e1f028f78fcf831c2cad3ec31c1.png";